"use client";

import { useContext, useEffect } from "react";
import Featured from "../Featured";
import VouchersList from "./VouchersList";
import Introduction from "@/components/Introduction";
import { LanguageContext } from "@/context/languageContext";
import { FeaturedComponent } from "@/types/modules";
import { VouchersOptions } from "@/types/wordpress";
import { Voucher } from "@/types/wordpress";
import { useLanguageUrl } from "@/context/languageURLContext";

interface VouchersComponentProps {
  vouchersData: Voucher[];
  vouchersOptions: VouchersOptions;
}

export default function VouchersComponent({
  vouchersData,
  vouchersOptions,
}: VouchersComponentProps) {
  const { language } = useContext(LanguageContext);

  const { url, setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(`/${language === "en" ? "de" : "en"}/vouchers`);
  }, [language, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor:
      language === "en"
        ? vouchersOptions.vouchersOptions.featured.backgroundColor
        : vouchersOptions.vouchersOptionsDE.featured.backgroundColor,
    title:
      language === "en"
        ? vouchersOptions.vouchersOptions.featured.title
        : vouchersOptions.vouchersOptionsDE.featured.title,
    custom:
      language === "en"
        ? vouchersOptions.vouchersOptions.featured.custom
        : vouchersOptions.vouchersOptionsDE.featured.custom,
  };

  return (
    <>
      <Introduction
        title={
          language === "en"
            ? vouchersOptions.vouchersOptions.introduction.title
            : vouchersOptions.vouchersOptionsDE.introduction.title
        }
        content={
          language === "en"
            ? vouchersOptions.vouchersOptions.introduction.content
            : vouchersOptions.vouchersOptionsDE.introduction.content
        }
      />
      <VouchersList vouchers={vouchersData} />
      <Featured featured={featured} />
    </>
  );
}
